(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4045],{

/***/ 49723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CarouselThumbs": function() { return /* binding */ CarouselThumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var _Card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74821);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7500);
/* harmony import */ var _contexts_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13560);
/* harmony import */ var _mui_material_CardActionArea__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9974);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88494);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71911);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_thumbs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75083);
/* harmony import */ var swiper_css_thumbs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_thumbs__WEBPACK_IMPORTED_MODULE_8__);















var SwiperContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e17b0l5d0"
})(function() {
    return {
        width: "100%",
        overflow: "hidden",
        "& > .swiper-autoheight": {
            height: "100%"
        }
    };
});
var CarouselThumbs = function(props) {
    var items = props.items, className = props.className, swiperOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "items",
        "className"
    ]);
    var appContext = (0,_contexts_AppContext__WEBPACK_IMPORTED_MODULE_4__/* .useAppContext */ .bp)();
    var ref = appContext.useConfig(), assetUrl = ref.assetUrl, componentOptions = ref.componentOptions;
    var channel = react__WEBPACK_IMPORTED_MODULE_0__.useRef(new Date().getTime().toString(36));
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(), 2), thumbsSwiper = ref1[0], setThumbsSwiper = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(items || []), 1), slides = ref2[0];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(SwiperContainer, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                    spaceBetween: 0,
                    centeredSlides: false,
                    thumbs: {
                        swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                    },
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .Autoplay */ .pt,
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5,
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .Thumbs */ .o3,
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .Virtual */ .eZ
                    ],
                    virtual: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true
                    }
                }, swiperOptions), {
                    children: slides.map(function(item, index) {
                        /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                            virtualIndex: index,
                            children: (item === null || item === void 0 ? void 0 : item.id) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_mui_material_CardActionArea__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                component: _Link__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r,
                                href: "/game/".concat(item.slug),
                                title: item.name || undefined,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Card__WEBPACK_IMPORTED_MODULE_2__/* .CardAsset */ .HW, {
                                    src: "".concat(assetUrl).concat(item.images.cover16x9 || item.images.cover, "/"),
                                    alt: item.name || "Cover",
                                    width: componentOptions.component_card_width || 512,
                                    height: componentOptions.component_card_height || 288,
                                    priority: index === 0,
                                    layout: "responsive",
                                    sizes: "(min-width:1200px) 33.333vw, (min-width:900px) 66.333vw, 100vw"
                                })
                            })
                        }, "".concat(channel === null || channel === void 0 ? void 0 : channel.current).concat(index, "a"));
                    })
                }))
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(SwiperContainer, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                    spaceBetween: 0,
                    slidesPerView: 4,
                    onSwiper: setThumbsSwiper,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5,
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .Thumbs */ .o3,
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .Virtual */ .eZ
                    ],
                    virtual: true,
                    breakpoints: {
                        1536: {
                            direction: "vertical",
                            autoHeight: true
                        },
                        0: {
                            direction: "horizontal",
                            slidesPerView: 4
                        }
                    },
                    children: (items || []).map(function(item, index) {
                        /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                            virtualIndex: index,
                            children: (item === null || item === void 0 ? void 0 : item.id) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_mui_material_CardActionArea__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Card__WEBPACK_IMPORTED_MODULE_2__/* .CardAsset */ .HW, {
                                    src: "".concat(assetUrl).concat(item.images.cover16x9 || item.images.cover, "/"),
                                    alt: item.name || "Cover",
                                    width: componentOptions.component_card_width || 512,
                                    height: componentOptions.component_card_height || 288,
                                    layout: "responsive",
                                    sizes: "(min-width:1200px) 8.333vw, (min-width:900px) 12.5vw, 25vw"
                                })
                            })
                        }, "".concat(channel === null || channel === void 0 ? void 0 : channel.current).concat(index, "b"));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CarouselThumbs);


/***/ }),

/***/ 75083:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);